import { Component, OnInit, Input } from '@angular/core';
import { count, max } from 'rxjs/operators';

@Component({
  selector: 'app-stars-meter',
  templateUrl: './stars-meter.component.html',
  styleUrls: ['./stars-meter.component.css']
})
export class StarsMeterComponent implements OnInit {

  constructor() { }

  @Input()
  count;

  @Input()
  max;

  stars = [];

  color = "gold";
  ngOnInit() {
    console.log(this.count);
    
    for(let i = 0; i < this.max; i++){

      this.stars.push(this.count>i);
      
    }
    if( (this.count/this.max) < 0.5) this.color = "red";
    console.log(this.stars);
    
  }

}
